import { Base } from '@studiometa/js-toolkit';

/**
 * SelectLink component
 */
export default class SelectLink extends Base {
  static config = {
    name: 'SelectLink',
    log: true,
  };

  /**
   * value
   * @returns {string}
   */
  get value() {
    return this.$el.value ?? '';
  }

  /**
   * target
   * @returns {string}
   */
  get target() {
    return this.$el.querySelector(`option[value="${this.value}"]`)?.dataset?.target ?? '';
  }

  /**
   * Go
   * @returns {void}
   */
  go() {
    if (this.value.length < 0) {
      return;
    }
    if (this.target.length > 0) {
      window.open(this.value, this.target).focus();
      return;
    }
    window.location.href = this.value;
  }
}
